import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import TopsTileNavigation from '@components/collections/Tops/TopsTileNavigation';

import styles from '@theme/templates/misc/CollectionCarousel.module.scss';

const CollectionCarousel = () => {
	const { liveCollections } = window.pageContext;
	const collections = [
		{
			title: 'View All Tops',
			tileImage: 'https://cdn.shopify.com/s/files/1/1147/9910/files/all-tops-module_homepage_desktop.png?v=1655168011',
			handle: 'top-frames',
			collectionIcon: false,
		},
		...liveCollections,
	];

	return (
		<div className={styles.section}>
			<TopsTileNavigation collections={collections} heading='Browse Our Collections' />
		</div>
	);
};

const rootElement = document.getElementById('HomePageCollectionCarouselRoot');
ReactDOM.render(<CollectionCarousel />, rootElement);
